<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-math-log</v-icon>{{$t('version.changelog.changelogs')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ChangeLogForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ChangeLogForm from '../../components/changelog/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ChangeLog';

const { mapFields } = createHelpers({
  getterType: 'changelog/getField',
  mutationType: 'changelog/updateField'
});

export default {
  name: 'ChangeLogCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ChangeLogForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('changelog', ['create', 'reset'])
  }
};
</script>
